export default __webpack_public_path__ + "static/media/a011-startup-05.e69fe344.svg";